import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../../baseQuery';
import { QueryParamsType, ResponseUsersType } from './type';

export const usersApi = createApi({
  reducerPath: 'usersApi',
  tagTypes: ['Users'],
  refetchOnReconnect: true,
  keepUnusedDataFor: 15,
  baseQuery: baseQueryWithReauth(),
  endpoints: (build) => ({
    getUsers: build.query<ResponseUsersType, QueryParamsType>({
      query: ({ page, per_page, search }) => ({
        url: '/users',
        method: 'GET',
        params: { page, per_page, search },
      }),
      providesTags: () => ['Users'],
    }),
  }),
});

export const { useGetUsersQuery } = usersApi;
